import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { TrendingUp } from 'lucide-react';
const Statistics = () => {
  return <div className="flex h-screen bg-gray-50" data-id="element-3581">
      <div className="w-20 flex-shrink-0" data-id="element-3582">
        <Sidebar data-id="element-3583" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3584">
        <Topbar data-id="element-3585" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-3586">
          <PageHeader title="Statistiche" subtitle="Analytics e reportistica avanzata" data-id="element-3587" />

          {/* Placeholder */}
          <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-3588">
            <div className="text-center" data-id="element-3589">
              <TrendingUp className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-3590" />
              <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-3591">
                Statistiche
              </h2>
              <p className="text-gray-500 max-w-md mx-auto" data-id="element-3592">
                Questa pagina conterrà statistiche avanzate. Coming soon.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default Statistics;